import { Document, DisplayDocument } from "../types/types";

export function formatDocuments(documents: Document[]) {
  const formattedDocuments: DisplayDocument[] = [];

  documents.forEach((document) => {
    let docType = "folder";

    if (document.name.includes(".png") || document.name.includes(".jpg")) {
      docType = "photo";
    } else if (document.name.includes(".")) {
      let dotSplits = document.name.split(".");
      docType = dotSplits[dotSplits.length - 1];
    }

    formattedDocuments.push({
      key: document.id,
      name: document.name,
      value: document.name,
      iconName: `https://static2.sharepointonline.com/files/fabric/assets/item-types/16/${docType}.svg`,
      fileType: docType !== "folder" ? document.name.split(".")[1] : "folder",
      modifiedBy: document.lastModifiedBy.user.displayName,
      dateModified: new Date(
        document.lastModifiedDateTime
      ).toLocaleDateString(),
      dateModifiedValue: document.lastModifiedDateTime.valueOf(),
      fileSize: formatBytes(document.size),
      fileSizeRaw: document.size,
      downloadUrl: document["@microsoft.graph.downloadUrl"],
      webUrl: document.webUrl
    });
  });
  return formattedDocuments;
}

export const FILE_ICONS: { name: string }[] = [
  { name: "accdb" },
  { name: "audio" },
  { name: "code" },
  { name: "csv" },
  { name: "docx" },
  { name: "dotx" },
  { name: "mpp" },
  { name: "mpt" },
  { name: "model" },
  { name: "one" },
  { name: "onetoc" },
  { name: "potx" },
  { name: "ppsx" },
  { name: "pdf" },
  { name: "photo" },
  { name: "pptx" },
  { name: "presentation" },
  { name: "potx" },
  { name: "pub" },
  { name: "rtf" },
  { name: "spreadsheet" },
  { name: "txt" },
  { name: "vector" },
  { name: "vsdx" },
  { name: "vssx" },
  { name: "vstx" },
  { name: "xlsx" },
  { name: "xltx" },
  { name: "xsn" },
];

function formatBytes(a: number, b = 2): string {
  if (0 === a) return "0 Bytes";
  const c = 0 > b ? 0 : b,
    d = Math.floor(Math.log(a) / Math.log(1024));
  return (
    parseFloat((a / Math.pow(1024, d)).toFixed(c)) +
    " " +
    ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
  );
}
